// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Oqfc","containerItemsCenter":"Skeleton_containerItemsCenter__1wjH0"};